import "../../../../lib/store/createAppApi.js";
import "../../../../lib/store/createAppAsyncThunk.js";
import { createAppSelector } from "../../../../lib/store/createAppSelector.js";
import "../../../../lib/store/createAppSlice.js";
import "react";
import "redux";
import "../../../../lib/store/hooks/useAppDispatch.js";
import "../../../../lib/store/hooks/useAppSelector.js";
import "../../../../lib/store/hooks/useAppStore.js";
import { selectSlice } from "./selectSlice.js";
const selectSort = createAppSelector(selectSlice, (config) => {
  const { sort } = config;
  return {
    ...sort,
    enable: (sort == null ? void 0 : sort.enable) ?? true,
    initialValues: (sort == null ? void 0 : sort.initialValues) ?? [],
    items: (sort == null ? void 0 : sort.items.map((item) => ({
      ...item,
      key: Array.isArray(item.key) ? item.key : [item.key]
    }))) ?? []
  };
});
export {
  selectSort
};
